import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Form, Button, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Messages from "../components/Messages";
import { updateUser, resetUpdate } from "../actions/userActions";
import { updateManager } from "../actions/managersActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  Container,
  CardHeader,
  CardHeaderTitle,
  StyledInput,
  ModernButton,
  SettingsCard,
  SectionTitle,
  Text,
  GridContainer,
  CustomSpan,
  StyledSelect,
  PasswordContainer,
  StyledPasswordInput,
  PasswordToggleIcon,
} from "../components/DefaultImports";

import styled from "styled-components";

function UpdateProfile() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = location.search ? location.search.split("=")[1] : "/";

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const userUpdate = useSelector((state) => state.userUpdate);
  const { success } = userUpdate;

  const manager_info = useSelector((state) => state.crudManager);
  const { managerInfo } = manager_info;

  const [name, setName] = useState(userInfo.name);
  const [email, setEmail] = useState(userInfo.email);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [accountUpdated, setAccountUpdated] = useState(false);
  const [showPasswords, setShowPasswords] = useState(true);

  useEffect(() => {
    if (password !== confirmPassword) {
      setPasswordsMatch(false);
    } else {
      setPasswordsMatch(true);
    }

    if (success === true) {
      dispatch(resetUpdate());
      setAccountUpdated(true);
    }
  }, [password, confirmPassword, success, dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const userData = {
      id: userInfo.id,
      name,
      email,
      password,
    };

    if (managerInfo?.first_time_password_change === false) {
      dispatch(updateUser({ id: userInfo.id, password }));
      dispatch(updateManager(false, false, true, false));
      navigate(redirect);
    } else {
      dispatch(
        updateUser(passwordsMatch ? userData : { id: userInfo.id, name, email })
      );
    }
  };

  const handleCancel = () => {
    setName(userInfo.name);
    setEmail(userInfo.email);
    toast.success("Cancelado", { autoClose: 1000 });
  };

  return (
    <Container>
      <ToastContainer />
      <CardHeader>
        <CardHeaderTitle>Conta</CardHeaderTitle>
      </CardHeader>

      <Form onSubmit={handleSubmit}>
        <GridContainer>
          {/* Success Message */}
          {accountUpdated && (
            <SettingsCard>
              <Messages variant="success">Informações atualizadas!</Messages>
            </SettingsCard>
          )}

          {/* User Info */}
          {managerInfo?.first_time_password_change !== false && (
            <SettingsCard>
              <SectionTitle>Dados da conta</SectionTitle>
              <Text style={{ marginBottom: "0px" }}>Nome de utilizador</Text>
              <StyledInput
                required
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{ marginBottom: "0px" }}
              />
              <Text style={{ marginBottom: "0px" }}>Endereço de e-mail</Text>
              <StyledInput
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </SettingsCard>
          )}

          {/* Alert for First Time Password */}
          {managerInfo?.first_time_password_change === false && (
            <SettingsCard>
              <Alert variant="success">
                <Alert.Heading>
                  <i
                    className="fas fa-smile-beam"
                    style={{ marginRight: "10px" }}
                  ></i>
                  Olá!
                </Alert.Heading>
                <p>
                  Por sua segurança, necessitamos que troque a sua
                  palavra-passe.
                </p>
                <hr />
                <p className="mb-0">Vamos começar?</p>
              </Alert>
            </SettingsCard>
          )}

          {/* Password Update */}
          <SettingsCard>
            <SectionTitle>Alterar palavra-passe</SectionTitle>

            <PasswordContainer>
              <StyledPasswordInput
                type={showPasswords ? "password" : "text"}
                placeholder="Nova palavra-passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <PasswordToggleIcon
                onClick={() => setShowPasswords(!showPasswords)}
              >
                <FontAwesomeIcon icon={showPasswords ? faEyeSlash : faEye} />
              </PasswordToggleIcon>
            </PasswordContainer>

            <PasswordContainer>
              <StyledPasswordInput
                type={showPasswords ? "password" : "text"}
                placeholder="Confirmar palavra-passe"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <PasswordToggleIcon
                onClick={() => setShowPasswords(!showPasswords)}
              >
                <FontAwesomeIcon icon={showPasswords ? faEyeSlash : faEye} />
              </PasswordToggleIcon>
            </PasswordContainer>

            {!passwordsMatch && (
              <Form.Text className="text-danger">
                As palavras-passe não coincidem.
              </Form.Text>
            )}
          </SettingsCard>
        </GridContainer>

        {/* Submit Buttons */}
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <ModernButton type="submit" color="#EE754C">
            Guardar
          </ModernButton>
        </div>
      </Form>
    </Container>
  );
}

export default UpdateProfile;
